import { useState } from "react";

import { TextToolState } from "@impero-com/ui";
import { Row } from "@tanstack/react-table";

import { useUpdatePushReportResponsibleForUserMutation } from "org/user/queries/useUpdatePushReportResponsibleForUserMutation";
import { UserOrUserGroupOverview } from "utils/user";

import { PushReportResponsibleRow } from "./useUserPushReportsResponsibleListTable";

interface UseReplacePushReportResponsibleUtilsProps {
    userId: number;
    selectedRows: Row<PushReportResponsibleRow>[];
    deselectAll: () => void;
}

export function useReplacePushReportResponsibleUtils({
    userId,
    selectedRows,
    deselectAll,
}: UseReplacePushReportResponsibleUtilsProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutateAsync, isPending } =
        useUpdatePushReportResponsibleForUserMutation();

    const replaceUserToolState: TextToolState =
        selectedRows.length === 0 ? { type: "DISABLED" } : { type: "ENABLED" };

    const replaceUser = async (userOrGroup: UserOrUserGroupOverview) => {
        const pushReportConfigurationIds = selectedRows.map(
            (row) => row.original.id
        );
        const newUserId = userOrGroup.id;
        try {
            await mutateAsync({
                userId,
                data: { newUserId, pushReportConfigurationIds },
            });
            deselectAll();
            setIsModalOpen(false);
        } catch (error) {
            console.error(error);
        }
    };

    return {
        replaceUserToolState,
        isReplaceUserModalOpen: isModalOpen,
        openReplaceUserModal: () => setIsModalOpen(true),
        closeReplaceUserModal: () => setIsModalOpen(false),
        replaceUser,
        isReplacingUser: isPending,
    };
}
